module.exports = __webpack_public_path__ + "static/media/camera_icon.dbd352d5.svg";